import { BaseTooltipAction, TooltipState } from '../../types';

import { getBaseTooltipReducer } from './index';

export type GrammarValidationAction = BaseTooltipAction | 'validation-error' | 'in-use' | 'size-exceed';

export const grammarValidationReducer = (state: TooltipState, action: GrammarValidationAction): TooltipState => {
    switch (action) {
        case 'validation-error':
            return {
                tooltipVisible: true,
                tooltipLabel: 'Ошибка валидации',
                tooltipTheme: 'error',
            };

        case 'in-use':
            return {
                tooltipVisible: true,
                tooltipLabel: 'Произошла ошибка. Возможно была удалена используемая сущность.',
                tooltipTheme: 'error',
            };

        case 'size-exceed':
            return {
                tooltipVisible: true,
                tooltipLabel: 'Размер скомпилированной грамматики не должен превышать 59000 символов',
                tooltipTheme: 'error',
            };

        default:
            return getBaseTooltipReducer({ successLabel: 'Сохранено' })(state, action);
    }
};
